/**
 * @prettier
 */
import { BeMeasuredPage } from "./BeMeasured";

export default BeMeasuredPage;
